module.exports = __webpack_public_path__ + "img/error-page.c14459a0.png";